import { getMasterContactIdFromScreenPop } from "../../utils/index.js";

export class CallContactEvent {
  constructor(json) {
    this.type = json.Type;
    this.contactId = json.ContactID;
    this.status = json.Status;
    this.originalState = json.OriginalState;
    this.callType = json.CallType;
    this.dnis = json.DNIS;
    this.ani = json.ANI;
    this.skill = json.Skill;
    this.rawIsInbound = json.IsInbound;
    // Coerce various boolean representations to actual booleans
    this.isInbound = String(json.IsInbound).toLowerCase() === "true";
    this.startTime = json.StartTimeUTC;
    this.lastUpdateTime = json.LastStateChangeTimeUTC;
    this.screenPopUrl = json.ScreenPopUrl;
    this.screenPopVariables = json.ScreenPopUrlVariables;
    this.disconnectCode = json.DisconnectCode;
    this.isLogging = json.IsLogging;
    this.timeout = json.Timeout;
    this.allowDispositions = json.AllowDispositions;
    this.label = json.Label;
    this.isLinked = json.IsLinked;
    this.timeZones = json.TimeZones;
    this.finalState = String(json.FinalState).toLowerCase() === "true";
  }

  get description() {
    return `${this.type} #${this.contactId} -> ${this.status} (IsInbound=${this.isInbound})`;
  }

  get referenceNumber() {
    // Prefer variables, but fall back to parsing the screenPop URL if necessary
    return (
      getMasterContactIdFromScreenPop(this.screenPopVariables) ??
      getMasterContactIdFromScreenPop(this.screenPopUrl)
    );
  }
}
